import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
} from '@mui/material';
import {
  MonetizationOn,
  AccessTime,
  Today,
} from '@mui/icons-material';

export {}; // Make this a module

interface Board {
  id: string;
  name: string;
  type: string;
  description: string;
  capacity: number;
  availabilitySettings: any;
  pricing: any;
  amenities?: string[];
  policies?: any;
  rules?: string;
  cancellationPolicy?: string;
}

interface PricingSectionProps {
  board: Board | null;
}

const PricingSection: React.FC<PricingSectionProps> = ({ board }) => {
  if (!board?.pricing) return null;

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
        💰 Precios y Tarifas
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
        {board.pricing?.basePrice && (
          <Card sx={{ minWidth: 200, bgcolor: 'success.light', color: 'white', borderRadius: 2 }}>
            <CardContent sx={{ textAlign: 'center', py: 3 }}>
              <MonetizationOn sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant="h4" fontWeight="bold">
                ${board.pricing.basePrice.toLocaleString()}
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                Precio Base
              </Typography>
            </CardContent>
          </Card>
        )}
        {board.pricing?.perHour && (
          <Card sx={{ minWidth: 200, bgcolor: 'info.light', color: 'white', borderRadius: 2 }}>
            <CardContent sx={{ textAlign: 'center', py: 3 }}>
              <AccessTime sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant="h4" fontWeight="bold">
                ${board.pricing.perHour.toLocaleString()}
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                Por Hora
              </Typography>
            </CardContent>
          </Card>
        )}
        {board.pricing?.perDay && (
          <Card sx={{ minWidth: 200, bgcolor: 'warning.light', color: 'white', borderRadius: 2 }}>
            <CardContent sx={{ textAlign: 'center', py: 3 }}>
              <Today sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant="h4" fontWeight="bold">
                ${board.pricing.perDay.toLocaleString()}
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                Por Día
              </Typography>
            </CardContent>
          </Card>
        )}
      </Box>
    </Box>
  );
};

export default PricingSection;